// Centralized brand/product fallback data for CIEDA's 4 brands

import productMayo from "@/assets/product-yousra-mayo.webp";
import productRice from "@/assets/product-yousra-rice.webp";
import productMeat from "@/assets/product-florida-meat.webp";
import productDetergent from "@/assets/product-kamax-detergent.webp";
import productSoap from "@/assets/product-kamix-soap.webp";
import productSoapBox from "@/assets/product-kamix-box.webp";
import brandDairy from "@/assets/brand-dairy.webp";
import productShelf from "@/assets/product-yousra-shelf.webp";

// Brand-based fallback image mapping (keyed by API brand slug)
export const BRAND_IMAGE_MAP: Record<string, string> = {
  yousra: productMayo,
  countre_dairy: brandDairy,
  florida: productMeat,
  kamax_kamix: productDetergent,
};

// Default product image when nothing else matches
export const DEFAULT_PRODUCT_IMAGE = productMayo;

// Fallback brand data for marquee/display when CMS is unavailable
export const FALLBACK_BRANDS = [
  { id: "fb-1", brand_name: "Countre Dairy", logo_url: null, cover_image_url: null, accent_color: "#89CFF0" },
  { id: "fb-2", brand_name: "Yousra", logo_url: null, cover_image_url: null, accent_color: "#F5DEB3" },
  { id: "fb-3", brand_name: "Florida", logo_url: null, cover_image_url: null, accent_color: "#F08080" },
  { id: "fb-4", brand_name: "KamaX / KamiX", logo_url: null, cover_image_url: null, accent_color: "#90EE90" },
] as const;

// Fallback brand filter chips for catalog section
export const FALLBACK_BRAND_FILTERS = [
  { brand_name: "Countre Dairy", slug: "countre-dairy" },
  { brand_name: "Yousra", slug: "yousra" },
  { brand_name: "Florida", slug: "florida" },
  { brand_name: "KamaX / KamiX", slug: "kamax-kamix" },
] as const;

// Fallback product showcase for BrandCards carousel
export interface FallbackProduct {
  id: string;
  name: string;
  brand: string;
  image: string;
}

export const FALLBACK_PRODUCTS: FallbackProduct[] = [
  { id: "p1", name: "Lait Countre Dairy", brand: "Countre Dairy", image: brandDairy },
  { id: "p2", name: "Mayonnaise Yousra", brand: "Yousra", image: productMayo },
  { id: "p3", name: "Riz Yousra", brand: "Yousra", image: productRice },
  { id: "p4", name: "Conserves Florida", brand: "Florida", image: productMeat },
  { id: "p5", name: "Détergent KamaX", brand: "KamaX", image: productDetergent },
  { id: "p6", name: "Savon KamiX", brand: "KamiX", image: productSoap },
  { id: "p7", name: "Savon KamiX Box", brand: "KamiX", image: productSoapBox },
  { id: "p8", name: "Gamme Yousra", brand: "Yousra", image: productShelf },
];
